// Tag groups: each subcategory bundles one or more `tag` values from the menu API.
// Shared by the drinks screen and the full-menu screen — one mapping, one truth.
export const TAG_GROUPS = {
  shake: ["shake", "shake-addon"],
  coffee: ["coffee", "coffee-addon"],
  tea: ["tea"],
  hydration: ["hydration"],
  juice: ["juice"],
  cooler: ["cooler"],
  soda: ["soda"],
};
